// src/store/slices/problemSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

const initialState = {
  problems: [],
  currentProblem: null,
  loading: false,
  error: null,
  totalCount: 0,
};

export const fetchProblems = createAsyncThunk(
  'problems/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const data = await api.get(`/problems/?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.data?.message || 'Failed to fetch problems');
    }
  }
);

export const fetchProblem = createAsyncThunk(
  'problems/fetchOne',
  async (id, { rejectWithValue }) => {
    try {
      const data = await api.get(`/problems/${id}/`);
      return data;
    } catch (error) {
      return rejectWithValue(error.data?.message || 'Failed to fetch problem');
    }
  }
);

export const createProblem = createAsyncThunk(
  'problems/create',
  async (problemData, { rejectWithValue }) => {
    try {
      const data = await api.post('/problems/', problemData);
      return data;
    } catch (error) {
      return rejectWithValue(error.data?.message || 'Failed to create problem');
    }
  }
);

const problemSlice = createSlice({
  name: 'problems',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentProblem: (state) => {
      state.currentProblem = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Problems
      .addCase(fetchProblems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProblems.fulfilled, (state, action) => {
        state.loading = false;
        state.problems = action.payload.results || [];
        state.totalCount = action.payload.count || 0;
      })
      .addCase(fetchProblems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Single Problem
      .addCase(fetchProblem.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProblem.fulfilled, (state, action) => {
        state.loading = false;
        state.currentProblem = action.payload;
      })
      .addCase(fetchProblem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Problem
      .addCase(createProblem.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createProblem.fulfilled, (state, action) => {
        state.loading = false;
        state.problems.unshift(action.payload);
      })
      .addCase(createProblem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearCurrentProblem } = problemSlice.actions;
export default problemSlice.reducer;